import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { tss } from 'tss-react/mui';
import { LightTooltip, NeedMoreTooltip } from './Requests/LightToolTip';
import { useIfVerifiedUser } from 'hooks/useUserState_utils';
import ShoppingCartOutlined from '@mui/icons-material/ShoppingCartOutlined';

export const OutOfStockSection = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const verified = useIfVerifiedUser();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2
      }}
    >
      <LightTooltip
        title={
          !verified ? (
            <NeedMoreTooltip />
          ) : (
            t('actionButtons.request.tooltips.outOfStock')
          )
        }
      >
        <div>
          <Button variant="outlined" disabled sx={{ gap: 1 }}>
            <ShoppingCartOutlined /> Samples
          </Button>
        </div>
      </LightTooltip>
      <Box className={classes.chip}>
        <Typography>Product out of stock</Typography>
      </Box>
    </Box>
  );
};

const useStyles = tss.create(({ theme }) => ({
  chip: {
    display: 'flex',
    padding: `${theme.spacing(1)} ${theme.spacing(3)}`,
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
    background: theme.palette.secondary.main,
    borderRadius: 100
  }
}));
